module.exports = __webpack_public_path__ + "img/sauna_2.306a90de.jpeg";